import { useTranslation } from 'react-i18next'

import { categoryLabels } from '../constants'
import SearchResultItem from '../SearchResultItem/SearchResultItem'
import LoadingSkeleton from './LoadingSkeleton'
import * as Styles from './styles'

const CategorySection = ({ category, results, loading, activeIndex, startIndex, onSelect, onHover }) => {
  const { t } = useTranslation()
  if (!loading && results.length === 0) return null

  if (loading) {
    return (
      <>
        <Styles.CategoryHeader>{t(categoryLabels[category])}</Styles.CategoryHeader>
        <LoadingSkeleton />
      </>
    )
  }

  return (
    <>
      <Styles.CategoryHeader>{t(categoryLabels[category])}</Styles.CategoryHeader>
      {results.map((result, index) => (
        <SearchResultItem
          key={result.id}
          result={result}
          active={startIndex + index === activeIndex}
          onClick={() => onSelect(result)}
          onMouseEnter={() => onHover(startIndex + index)}
        />
      ))}
    </>
  )
}

export default CategorySection
